// extracted by mini-css-extract-plugin
module.exports = {"blockCompanion":"index-shimmer_blockCompanion__8GhOV","placeholderShimmer":"index-shimmer_placeholderShimmer__2CEMA"};